"use strict";import{IconCross75 as o}from"../src/elements/IconCross75.js";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";e("sp-icon-cross75",o);
//# sourceMappingURL=sp-icon-cross75.js.map
